import React from 'react';
import {
  Container,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Grid,
  Box,
  useTheme,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import CoreValues from '../CoreValues';
import ImageCard from '../ImageCard';

const coaches = [
  {
    name: 'Susana Jung',
    title: 'Founder',
    bio: 'Susana founded the swim school and has a passion for teaching swimming to all age groups, focusing on skill development and water confidence.',
    img: '/images/img-6.jpg',
  },
  {
    name: 'Tony Koh',
    title: 'Head Coach',
    bio: 'Tony is dedicated to helping swimmers improve their form and endurance, with a keen interest in swimming and fitness.',
    img: '/images/img-8.jpg',
  },
  {
    name: 'Andy Koh',
    title: 'Head Coach',
    bio: 'A former competitive swimmer, loves teaching and focuses on advanced techniques and skill-building for all levels.',
    img: '/images/img-7.jpg',
  },
  {
    name: 'Esther Joo',
    title: 'Instructor',
    bio: 'Esther has a passion for working with swimmers, helping them build confidence in the water while mastering essential techniques. She creates a fun and encouraging environment for every lesson.',
    img: '/images/img-8.jpg',
  },
  {
    name: 'Daniel Jo',
    title: 'Instructor',
    bio: 'Daniel brings energy and dedication to every class, focusing on developing strong swimming fundamentals and water safety skills. He enjoys seeing swimmers grow and achieve their goals.',
    img: '/images/img-8.jpg',
  },
  {
    name: 'Naree Shin',
    title: 'Instructor',
    bio: 'Naree is passionate about teaching swimmers of all levels and takes pride in helping them improve their skills and confidence. She fosters a positive and motivating space for her students.',
    img: '/images/img-8.jpg',
  },
  {
    name: 'Julie Shin',
    title: 'Instructor',
    bio: 'Julie loves guiding new swimmers through their first strokes and supporting experienced swimmers to refine their technique. She is committed to creating an enjoyable and safe learning experience.',
    img: '/images/img-8.jpg',
  },
];

const AboutUs = () => {
  const theme = useTheme();

  const boxStyle = {
    p: 2,
    borderRadius: 2,
    boxShadow: 3,
    bgcolor: theme.palette.primary.main,
    color: theme.palette.background.paper,
    mb: 2,
  };

  return (
    <Container sx={{ mt: 4 }}>
      {/* Section for Swim Club Info */}
      <Typography
        variant="h1"
        sx={{ textAlign: 'center', color: theme.palette.primary.main }}
        gutterBottom
      >
        About Us
      </Typography>

      <Grid container spacing={4} sx={{ mb: 5 }}>
        <Grid item xs={12} md={6}>
          <Typography variant="body1" sx={{ textAlign: 'justify', lineHeight: 1.8 }}>
            SJ Swimming started back in 2012 when our now Head Coach Susana began offering small private swimming lessons in New Zealand. What started as a simple passion for teaching soon blossomed into something bigger. Over the years, we've grown from those humble beginnings into a thriving swim community built on trust, dedication, and a shared love for the water.
            <br /><br />
            At SJ Swimming, we're all about helping swimmers of every level improve their skills, build confidence, and feel at home in the water. Whether you're dipping your toes in for the first time or training for competitive events, our experienced and supportive coaches are here to guide you every step of the way.
            <br /><br />
            Join the SJ Swimming family and become part of a community that's passionate about growth, learning, and making a splash together!
          </Typography>
        </Grid>

        <Grid item xs={12} md={6}>
          <ImageCard
            src="/images/SJ_Gallery/SQ_1_5.jpg"
            alt="Our semi-squad Knox class"
          />
        </Grid>
      </Grid>

      {/* Section for Coaches */}
      <Typography
        variant="h2"
        sx={{ textAlign: 'center', mt: 5, mb: 4, color: theme.palette.primary.main }}
      >
        Meet Our Team
      </Typography>

      <Grid container spacing={3}>
        {coaches.map((coach, index) => (
          <Grid item xs={12} sm={6} md={4} key={index}>
            <Accordion sx={{ ...boxStyle }}>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon sx={{ color: theme.palette.background.paper }} />}
                aria-controls={`panel${index}-content`}
                id={`panel${index}-header`}
              >
                <Box sx={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                  <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
                    {coach.name}
                  </Typography>
                  <Typography variant="subtitle1" sx={{ fontWeight: 'bold' }}>
                    {coach.title}
                  </Typography>
                </Box>
              </AccordionSummary>
              <AccordionDetails sx={{ bgcolor: '#f7f7f7', color: '#17204a', borderRadius: 2 }}>
                <Grid container spacing={2} alignItems="center">
                  <Grid item xs={12}>
                    <Typography variant="body2" sx={{ textAlign: 'center' }}>
                      {coach.bio}
                    </Typography>
                  </Grid>
                </Grid>
              </AccordionDetails>
            </Accordion>
          </Grid>
        ))}
      </Grid>

      {/* Core Values Section */}
      <CoreValues />
    </Container>
  );
};

export default AboutUs;